import { render, staticRenderFns } from "./file_page.vue?vue&type=template&id=5c4ae9f4&scoped=true"
import script from "./file_page.vue?vue&type=script&lang=js"
export * from "./file_page.vue?vue&type=script&lang=js"
import style0 from "./file_page.vue?vue&type=style&index=0&id=5c4ae9f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ae9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4ae9f4')) {
      api.createRecord('5c4ae9f4', component.options)
    } else {
      api.reload('5c4ae9f4', component.options)
    }
    module.hot.accept("./file_page.vue?vue&type=template&id=5c4ae9f4&scoped=true", function () {
      api.rerender('5c4ae9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/file_page.vue"
export default component.exports